import { render, staticRenderFns } from "./OnboardingItemEdit.vue?vue&type=template&id=47a6c2a6"
import script from "./OnboardingItemEdit.js?vue&type=script&lang=js&external"
export * from "./OnboardingItemEdit.js?vue&type=script&lang=js&external"
import style0 from "./OnboardingItemEdit.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports